module.exports = __webpack_public_path__ + "static/media/DSCF0078.4e8900db.jpg";